var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"login-div"},[_c('div'),_c('div',{staticClass:"login-form"},[(_vm.isLogin)?_c('comLogin',{attrs:{"sendData":_vm.getData}}):_c('comSign',{attrs:{"sendData":_vm.getData}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }